import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { AllotteAccommodationToAttendeeAsync, getAllAccommodationsAsync } from './familyFestAccommodationThunk';
const initialState = {
    status: APIStatus.IDLE,
    accommodationDetails: null,
    selectedAccommodationAttendee: null
};
export const familyFestAccommodationSlice = createSlice({
    name: 'familyFestAccommodation',
    initialState,
    reducers: {
        resetAccommodationStatus: (state) => {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllAccommodationsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllAccommodationsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.accommodationDetails = action.payload;
        })
            .addCase(getAllAccommodationsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
        });
        builder
            .addCase(AllotteAccommodationToAttendeeAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(AllotteAccommodationToAttendeeAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.selectedAccommodationAttendee = action.payload;
        })
            .addCase(AllotteAccommodationToAttendeeAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
        });
    }
});
export const { resetAccommodationStatus } = familyFestAccommodationSlice.actions;
export default familyFestAccommodationSlice.reducer;
